export const fontSizes = {
  Small: {
    name: 'Small',
    value: 1,
    ratio: 1,
  },
  Medium: {
    name: 'Medium',
    value: 2,
    ratio: 1.1,
  },
  Large: {
    name: 'Large',
    value: 3,
    ratio: 1.2,
  },
}

export const DEFAULT_TYPE_FONT_SIZE = fontSizes.Medium.name
export const DEFAULT_FONT_SIZE = 12
